import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import XrDashboard from './components/Dashboard/Dashboard';
import XrDetails from './components/Dashboard/Details';
import XrPlay from './components/Dashboard/PlayResource';
import AssetDashboard from './components/3DAssets/Dashboard';
import AssetDetails from './components/3DAssets/Details';


const AppRouter = () => {
  const defaultRoute = `/dashboard/xr`;

  return (
    <Routes>
      <Route path="/dashboard/xr" element={<XrDashboard />} />
      <Route path="/dashboard/xr/details/:id" element={<XrDetails />} />
      <Route path="/dashboard/xr/play/:id" element={<XrPlay />} />
      <Route path="/dashboard/3d" element={<AssetDashboard />} />
      <Route path="/dashboard/3d/details/:id" element={<AssetDetails />} />
      <Route path='*' element={<Navigate to={defaultRoute} />} />
    </Routes>
  )
}

export default AppRouter;